import { Component } from '@angular/core';
import { ErrorService } from './core/service/error.service';
import { MenuService } from './core/service/menu.service';
import { Title } from '@angular/platform-browser';

//const VConsole = require('VConsole');
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  errorContent: string[];
  isShowError = false;

  constructor(
    
    private errorService: ErrorService,
    private MenuService: MenuService,
    private title: Title
  ) { 
     //const vConsole = new VConsole();
  }

  ngOnInit() {
    this.initializeErrors();
    const companyID = sessionStorage.getItem("CompanyID")??"";
    this.MenuService.GetCompany(companyID).subscribe(res=>{
      const name = res.name || "";
      this.title.setTitle(`線上預約 - ${name}`);
    });
  }

  private initializeErrors() {
    var that = this;

    this.errorService
      .getErrors()
      .subscribe((errors) => {
        if (errors && errors.length > 0) {
          that.errorContent = errors;
          that.isShowError = true;
        }else{
          that.errorContent = [];
          that.isShowError = false;
        }
      });
  }
}
